export enum ImageTypes {
    STYLES = 'styles'
}
